// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/sedi?societaId={id}&commerciale=true',
    requestBody: null,
    response: '{"sedi":[{"id":"number","nome":"string","sedeCommerciale":"boolean"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/codici-iva?societaId={id}&attivo=true',
    requestBody: null,
    response: '{"codici":[{"id":"number","codice":"string","descrizione":"string","aliquota":"string","attivo":"boolean","predefinito":"boolean"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse/:id',
    requestBody: null,
    response: '{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string","sedeId":"number","sedeNome":"string","offertaCapitolatoId":"number|null","codiceIvaDefaultId":"number|null","codiceIvaDefault":{"id":"number","codice":"string","descrizione":"string","aliquota":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/offerte-capitolato/:id',
    requestBody: null,
    response: '{"success":true,"data":{"id":"number","codice":"string","ricarico":"string","tipoFatturazione":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse/:id/acquirenti',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","unitaCodice":"string","nome":"string","cognome":"string"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi?ruolo=CLIENTE&societaId={id}&q={q}&limit=20',
    requestBody: null,
    response: '{"data":[{"id":"number","ragioneSociale":"string","nome":"string","cognome":"string","codice":"string","tipoSoggetto":"AZIENDA|PRIVATO"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/nominativi/:id',
    requestBody: null,
    response: '{"id":"number","cliente":{"codiceIvaDefaultId":"number|null","codiceIvaDefault":{"id":"number","codice":"string","descrizione":"string"}}}'
  },
  {
    method: 'GET',
    endpoint: '/api/commesse?societaId={id}&search={q}',
    requestBody: null,
    response: '{"commesse":[{"id":"number","numero":"string","descrizione":"string","clienteRagioneSociale":"string","offertaCapitolatoId":"number|null","sedeId":"number","sedeNome":"string","codiceIvaDefaultId":"number|null"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi',
    requestBody: '{"societaId":"number","tipoSoggetto":"AZIENDA|PRIVATO","ragioneSociale":"string?","nome":"string?","cognome":"string?","emailPrincipale":"string?","telefono":"string?"}',
    response: '{"id":"number","codice":"string","tipoSoggetto":"string"}'
  },
  {
    method: 'POST',
    endpoint: '/api/nominativi/:id/abilita-cliente',
    requestBody: '{"categoriaCliente":"AZIENDA_B2B|PRIVATO_B2C"}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/preventivi',
    requestBody: '{"societaId":"number","sedeId":"number","tipo":"string","flussoCommerciale":"VENDITA|APPALTO_CONTRATTO","oggetto":"string","dataEmissione":"string","dataValidita":"string?","codiceIvaDefaultId":"number","nominativoId":"number?","acquirenteId":"number?","commessaId":"number?"}',
    response: '{"success":true,"data":{"id":"number","numero":"string"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/preventivi?societaId={id}&tipo={tipo}&flussoCommerciale={flusso}&stato={stato}&q={q}&includiSuperati={bool}',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","numero":"string","versione":"number","tipo":"string","flussoCommerciale":"string","stato":"string","oggetto":"string","dataEmissione":"string","clienteRagioneSociale":"string","totaleCliente":"string","commessa":{"id":"number","numero":"string"},"acquirente":{"id":"number","nome":"string","cognome":"string","unitaCodice":"string"}}]}'
  },
  {
    method: 'DELETE',
    endpoint: '/api/preventivi/:id?ripristinaOrigine=0|1',
    requestBody: null,
    response: '{"success":true,"data":{"origineRipristinata":{"id":"number","numero":"string","stato":"string"}|null}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
